// Catalogo central de tipos de negocio para el SaaS Commandix.
// Usado en signup, onboarding y configuracion de templates.
// El value es estable (slug en español) — NO renombrar sin migrar la DB.

export const BUSINESS_CATEGORIES = [
  {
    label: "Estética y Belleza Avanzada",
    icon: "💉",
    types: [
      { value: "estetica_facial", label: "Centro de estética facial (limpiezas, acné, rejuvenecimiento)" },
      { value: "estetica_avanzada", label: "Estética avanzada (Botox, ácido hialurónico, láser)" },
      { value: "uñas", label: "Uñas (manicure, pedicure, acrílicas, gel)" },
      { value: "pestañas_cejas", label: "Pestañas / Cejas (extensiones, microblading, lifting)" },
      { value: "salon_completo", label: "Salón completo (cabello, tintes, tratamientos)" },
      { value: "spa_masajes", label: "Spa / Masajes (relajantes, reductores, terapias)" },
    ],
  },
  {
    label: "Belleza y Servicios Personales",
    icon: "💄",
    types: [
      { value: "peluqueria", label: "Peluquería / Barbería" },
      { value: "manicurista", label: "Manicurista / Salón de uñas" },
      { value: "maquillista", label: "Maquillista / Estilista" },
      { value: "masajista", label: "Masajista / Spa" },
    ],
  },
  {
    label: "Call Centers y Equipos de Ventas",
    icon: "📞",
    types: [
      { value: "call_center", label: "Call Center / Telemarketing" },
      { value: "ventas", label: "Equipo de ventas" },
    ],
  },
  {
    label: "Comida y Delivery",
    icon: "🍔",
    types: [
      { value: "restaurante", label: "Restaurante / Comida casera" },
      { value: "reposteria", label: "Repostería / Postres" },
      { value: "frituras", label: "Jugos / Batidas / Frituras" },
      { value: "delivery_whatsapp", label: "Delivery por WhatsApp" },
    ],
  },
  {
    label: "Colmados y Minimarkets",
    icon: "🛒",
    types: [
      { value: "colmado", label: "Colmado / Minimarket" },
      { value: "tienda_barrio", label: "Tienda de barrio" },
    ],
  },
  {
    label: "Tiendas y Ventas",
    icon: "👕",
    types: [
      { value: "tienda_ropa", label: "Tienda de ropa" },
      { value: "tienda_telefonos", label: "Tienda de teléfonos / electrónicos" },
      { value: "cosmeticos", label: "Cosméticos / perfumes / accesorios" },
      { value: "vapes", label: "Vapes y cigarrillos electrónicos" },
      { value: "ventas_redes", label: "Ventas por Instagram / WhatsApp" },
    ],
  },
  {
    label: "Servicios Técnicos",
    icon: "🔧",
    types: [
      { value: "reparacion_celulares", label: "Reparación de celulares" },
      { value: "tecnico_ac", label: "Técnico A/C / electricista / plomero" },
      { value: "mecanico", label: "Mecánico" },
    ],
  },
  {
    label: "Transporte y Servicios",
    icon: "🚚",
    types: [
      { value: "lavanderia", label: "Lavandería" },
      { value: "mensajeria", label: "Mensajería / motoristas" },
      { value: "mudanzas", label: "Mudanzas" },
      { value: "limpieza", label: "Limpieza / mantenimiento" },
      { value: "cuidados", label: "Cuidado de niños / envejecientes" },
    ],
  },
  {
    label: "Otro",
    icon: "⚡",
    types: [
      { value: "otro", label: "Otro tipo de negocio" },
    ],
  },
];

// Helper para resolver el label de un value
export function getBusinessTypeLabel(value) {
  for (const cat of BUSINESS_CATEGORIES) {
    const found = cat.types.find(t => t.value === value);
    if (found) return found.label;
  }
  return value;
}

// Catalogo plano para selects simples
export const FLAT_BUSINESS_TYPES = BUSINESS_CATEGORIES.flatMap(c => c.types);
